import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "004_accounting_receipt_link",
  version: "0.1.0",
  ignoreErrors: ["duplicate column name: accounting_receipt_id"],
  sql: `
ALTER TABLE \`dormitory_bills\` ADD COLUMN \`accounting_receipt_id\` text;
`,
};
